import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ToggleOnIcon } from '@/common/icons/ToggleOnIcon';
import { ToggleOffIcon } from '@/common/icons/ToggleOffIcon';

type OnOffToggleProps = {
  isOn: boolean;
  onChange: (o: boolean) => void;
  disabled?: boolean;
};

const useStyles: any = makeStyles(() => ({
  root: {
    '& button': {
      height: 24
    },
    '& button > span': {
      height: 25
    },
    '& button:hover': {
      backgroundColor: 'initial !important'
    }
  }
}));

const enabledStrokeColor = '#7f7e7e';
const disabledStrokeColor = '#B0BEC5';

const OnOffToggle = ({ onChange, isOn, disabled }: OnOffToggleProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <IconButton
        className={classes['button:hover']}
        size="medium"
        onClick={() => {
          !disabled ? onChange(!isOn) : null;
        }}
        disabled={disabled}
      >
        {isOn && <ToggleOnIcon fill={disabled ? disabledStrokeColor : null} />}
        {!isOn && (
          <ToggleOffIcon
            stroke={disabled ? disabledStrokeColor : enabledStrokeColor}
            fill={disabled ? disabledStrokeColor : enabledStrokeColor}
          />
        )}
      </IconButton>
    </div>
  );
};

export default OnOffToggle;
